/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["asb","gjk","gshk","gtsh","gjb","gjn"],["asʊbaa","gajaka","gɩshilikɔnɔ","gɩteŋshile","gɩjibɔŋɔ","gajanɩ"],u],[["asb","gjk","gshk","gtsh","gjb","gjn"],u,["asʊbaa","gajaka","gɩshilikɔnɔ","gɩteŋshile","gɩjibɔŋɔ","gajanɩ"]],[["04:00","07:00"],["07:00","12:00"],["12:00","16:00"],["16:00","20:00"],["20:00","24:00"],["00:00","04:00"]]];
